// extracted by mini-css-extract-plugin
export default {"titleContainer":"Animation_titleContainer__Qlfz7","initial":"Animation_initial__YLNOB","textContainer":"Animation_textContainer__7UfX0","scrolled":"Animation_scrolled__zwnca"};